import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/index'

Vue.use(Router);

export const CONSTANT_ROUTER_MAP = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error_page/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: '首页', icon: 'menu-home'}
      }
    ]
  }
]

export const ASYNC_ROUTER_MAP = [
  {
    path: '/works',
    component: Layout,
    redirect: '/works/list',
    name: 'works',
    meta: {title: '作品管理', icon: 'menu-works'},
    children: [
      {
        path: 'list',
        name: 'worksList',
        component: ()=> import('@/views/works/index'),
        meta: {title: '作品列表', icon: 'menu-list'}
      },
      {
        path: 'add',
        name: 'worksAdd',
        component: () => import('@/views/works/add'),
        meta: {title: '添加作品', icon: 'menu-add'}
      },
      {
        path: 'update',
        name: 'worksUpdate',
        hidden: true,
        component: () => import('@/views/works/update'),
        meta: {title: '修改作品', icon: 'menu-add'}
      },
      {
        path: 'homeHero',
        name: 'systemHomeHero',
        component: () => import('@/views/homeHero/WorksHeroDetail'),
        meta: {title: '首页 Hero', icon: 'menu-portal'}
      },
    ]
  },
  {
    path: '/awards',
    component: Layout,
    redirect: '/awards/list',
    name: 'awards',
    meta: {title: '奖项管理', icon: 'menu-awards'},
    children: [
      {
        path: 'list',
        name: 'awardsList',
        component: ()=> import('@/views/awards/index'),
        meta: {title: '奖项列表', icon: 'menu-list'}
      },
      {
        path: 'add',
        name: 'awardsAdd',
        component: () => import('@/views/awards/add'),
        meta: {title: '添加奖项', icon: 'menu-add'}
      },
      {
        path: 'update',
        name: 'awardsUpdate',
        hidden: true,
        component: () => import('@/views/awards/update'),
        meta: {title: '修改奖项', icon: 'menu-add'}
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '/business/list',
    name: 'business',
    meta: {title: '商务管理', icon: 'menu-business'},
    children: [
      {
        path: 'list',
        name: 'businessList',
        component: ()=> import('@/views/business/index'),
        meta: {title: '人员列表', icon: 'menu-list'}
      },
      {
        path: 'add',
        name: 'businessAdd',
        component: () => import('@/views/business/add'),
        meta: {title: '添加人员', icon: 'menu-add'}
      },
      {
        path: 'update',
        name: 'businessUpdate',
        hidden: true,
        component: () => import('@/views/business/update'),
        meta: {title: '修改人员', icon: 'menu-add'}
      }
    ]
  },
  {
    path: '/about',
    component: Layout,
    redirect: '/about/list',
    name: 'about',
    meta: {title: '首页管理', icon: 'menu-about'},
    children: [
      {
        path: 'list',
        name: 'aboutList',
        component: ()=> import('@/views/about/index'),
        meta: {title: '素材列表', icon: 'menu-list'}
      },
      {
        path: 'add',
        name: 'aboutAdd',
        component: () => import('@/views/about/add'),
        meta: {title: '添加素材', icon: 'menu-add'}
      },
      {
        path: 'update',
        name: 'aboutUpdate',
        hidden: true,
        component: () => import('@/views/about/update'),
        meta: {title: '修改素材', icon: 'menu-add'}
      }
    ]
  },
  {
    path: '/share',
    component: Layout,
    redirect: '/share/list',
    name: 'share',
    meta: {title: '首页管理', icon: 'menu-share'},
    children: [
      {
        path: 'list',
        name: 'shareList',
        component: ()=> import('@/views/share/index'),
        meta: {title: '素材列表', icon: 'menu-list'}
      },
      {
        path: 'add',
        name: 'shareAdd',
        component: () => import('@/views/share/add'),
        meta: {title: '添加素材', icon: 'menu-add'}
      },
      {
        path: 'update',
        name: 'shareUpdate',
        hidden: true,
        component: () => import('@/views/share/update'),
        meta: {title: '修改素材', icon: 'menu-add'}
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/mail',
    name: 'system',
    meta: {title: '系统配置', icon: 'menu-system'},
    children: [
      {
        path: 'mail',
        name: 'systemMail',
        component: () => import('@/views/system/MailDetail'),
        meta: {title: '邮件配置', icon: 'menu-mail'}
      },
      {
        path: 'social',
        name: 'systemSocial',
        component: () => import('@/views/system/SocialDetail'),
        meta: {title: '媒体配置', icon: 'menu-social'}
      },
      {
        path: 'portal',
        name: 'systemPortal',
        component: () => import('@/views/system/PortalDetail'),
        meta: {title: '门户配置', icon: 'menu-portal'}
      },
    ]
  },
  {
    path: '/permission',
    component: Layout,
    redirect: '/permission/admin',
    name: 'permission',
    meta: {title: '权限管理', icon: 'menu-permission'},
    children: [
      {
        path: 'admin',
        name: 'permissionAdmin',
        component: () => import('@/views/permission/admin/index'),
        meta: {title: '用户管理', icon: 'menu-admin'}
      },
      {
        path: 'role',
        name: 'permissionRole',
        component: () => import('@/views/permission/role/index'),
        meta: {title: '角色管理', icon: 'menu-role'}
      },
      {
        path: 'resource',
        name: 'permissionResource',
        component: () => import('@/views/permission/resource/index'),
        meta: {title: '资源管理', icon: 'menu-resource'}
      },
      {
        path: 'menu',
        name: 'permissionMenu',
        component: () => import('@/views/permission/menu/index'),
        meta: {title: '菜单管理', icon: 'menu-menu'}
      },
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  scrollBehavior: () => ({y: 0}),
  mode: 'history',
  routes: CONSTANT_ROUTER_MAP
})



// WEBPACK FOOTER //
// ./src/router/index.js